import { morphSection } from '@theme/section-renderer';
import { DiscountUpdateEvent } from '@theme/events';
document.addEventListener('click',async(event)=>{
 const button=event.target.closest('[data-ub-wallet-code]');
 if(!button || button.disabled)return;
 event.preventDefault();
 const panel=button.closest('.ub-rewards');
 const error=panel.querySelector('[data-ub-wallet-error]');
 button.disabled=true;error.hidden=true;
 try{
  const root=window.Shopify?.routes?.root||'/';
  const current=await fetch(root+'cart.js').then(r=>r.json());
  const codes=(current.discount_codes||[]).filter(d=>d.applicable&&!d.code.toUpperCase().startsWith('UBWALLET')).map(d=>d.code);
  if(button.dataset.ubWalletRemove!=='true')codes.push(button.dataset.ubWalletCode);
  const section=button.closest('cart-items-component')?.dataset.sectionId;
  if(!section)throw new Error('Please reopen the cart and try again.');
  const response=await fetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:codes.join(','),sections:[section],sections_url:window.location.pathname})});
  const data=await response.json();
  if(!response.ok)throw new Error(data.description||'Could not apply wallet.');
  if(button.dataset.ubWalletRemove!=='true'&&!(data.discount_codes||[]).some(d=>d.code.toUpperCase()===button.dataset.ubWalletCode&&d.applicable))throw new Error('Wallet cannot combine with this offer, or your cart no longer qualifies.');
  if(typeof data.sections?.[section]!=='string')throw new Error('Refresh the cart to see your updated total.');
  document.dispatchEvent(new DiscountUpdateEvent(data,'unbound-wallet'));
  await morphSection(section,data.sections[section]);
 }catch(e){error.textContent=e.message;error.hidden=false;button.disabled=false;}
});